/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Editor_Token_CopiedInputs */

const fr_settings_editor_token_copied = /** @type {(inputs: Settings_Editor_Token_CopiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jeton d'authentification copié dans le presse-papier !`)
};

const en_settings_editor_token_copied = /** @type {(inputs: Settings_Editor_Token_CopiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Authentication token copied to the clipboard!`)
};

/**
* | output |
* | --- |
* | "Authentication token copied to the clipboard!" |
*
* @param {Settings_Editor_Token_CopiedInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const settings_editor_token_copied = /** @type {((inputs?: Settings_Editor_Token_CopiedInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Editor_Token_CopiedInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_settings_editor_token_copied(inputs)
	return en_settings_editor_token_copied(inputs)
});